import styled from 'styled-components';
import { Row } from 'antd';

export const RowStyles = styled(Row)`
  .ant-select.ant-select-single.ant-select-show-arrow {
    background: #f2f2f2 !important;
    border-radius: 2px !important;
  }
  .ant-select-selector {
    background: #f2f2f2 !important;
    line-height: 16px;
    border: none !important;
    font-weight: normal;
    line-height: 16px;
    cursor: pointer;
    &:hover {
      border: none !important;
      line-height: 16px;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .ant-select,
  .ant-select-multiple,
  .ant-select-show-arrow,
  .ant-select-show-search {
    border: none;
    border-radius: 2px;
    padding: 4px;
    background: #f2f2f2;
    .ant-select-selection-overflow-item,
    .ant-select-multiple,
    .ant-select-selection-item {
      border: none;
      flex-direction: row-reverse;
      .ant-select-selection-item-remove {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-right: 2px;
        .anticon,
        .anticon-close {
          border-radius: 50%;
          border: ${props => `solid ${props?.iconColor || '#24a95d'} 1px`};
          padding: 2px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
        svg {
          color: ${props => props?.iconColor || '#24a95d'};
          font-weight: border;
        }
      }
      .ant-select-selection-item-content {
        padding: auto 4px;
        margin-left: 3px;
      }
    }
    .ant-select-arrow {
      svg {
        color: #707070;
      }
    }
  }
`;
